export { CrossIcon } from './cross'
